// extracted by mini-css-extract-plugin
export default {"root":"gVlOHx","image":"cChXg4"};